const Immersive3dTourSource = {
  MANUAL: 0,
  UI_CAPTURE: 1,
  // A sub-type of the source UI_CAPTURE
  // Same procedure with when the project comes from UI Capture app
  UI_CAPTURE_CUSTOM: 2,
};

export default Immersive3dTourSource;
